// extracted by mini-css-extract-plugin
export var container = "_3u-0";
export var disabled = "_3u-4";
export var fullWidth = "_3u-3";
export var lined = "_3u-1";
export var selected = "_3u-5";
export var tab = "_3u-2";